import { Injectable } from '@angular/core';
import { ServiceRepository } from './service-repository'
import { ConfigLoaderService } from './Config/config-loader.service'

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private _repositoryService: ServiceRepository
  ) {
   
   }

  getUserSession(userName:string){
    if(ConfigLoaderService.settings.env.name.toUpperCase()=="DEVELOPMENT"){
      return this._repositoryService.getDatawitHeaders('/api/UserRole/Devsession/'+ userName)
    }
    else{
      return this._repositoryService.getDatawitHeaders('/api/UserRole/session/'+ userName)

    }
  
   
  }

  getToken(userName:string,password:string){
    return this._repositoryService.postToken('/api/authentication/token' , userName ,password)
  }

  getUserRole(userName:string,sessionId:string){
    return this._repositoryService.getDatawitHeaders('/api/UserRole/GetUserRole/'+userName +'/'+sessionId  )
  }
}
